<td class="max-w-full items-center gap-x-4 truncate px-3.5 py-5 font-medium text-gray-800">
  <button iButton color="gray" variant="ghost" (click)="updateShareModal()">{{ dataShare().shareName }}</button>
</td>
<td class="truncate text-left text-xs">
  @if (!paused()) {
    <IBadge color="green" variant="soft" label="Active" size="sm" icon="check" />
  } @else {
    <IBadge color="blue" variant="soft" label="Paused" size="sm" icon="pause" />
  }
</td>
<td class="item-center truncate text-left text-slate-500">
  {{ dataShare().gcLocation }}
</td>
<td class="items-center truncate text-left text-slate-500">
  <button class="mx-2" iButton variant="secondary" (click)="openShareResourcesModal()">
    {{ dataShare().resources.length }}
  </button>
</td>
<td class="p-2 text-left">
  <button iButton variant="secondary" class="w-fit max-w-full" (click)="updateShareModal()">
    <div class="inline-flex truncate">
      {{ displaySharePrincipals() }}
    </div>
  </button>
</td>
<td class="truncate text-left text-slate-500">
  {{ lastPushedTime() }}
</td>
<td class="truncate px-3.5 text-left">
  @if (bigQueryButtonDisabled()) {
    <button
      iButton
      class="w-fit max-w-full"
      variant="secondary"
      (click)="openNewTabOnHost()"
      [disabled]="bigQueryButtonDisabled()"
      [iTooltip]="bigQueryButtonTooltip()"
    >
      <div class="inline-flex items-center gap-1 truncate">
        <IIcon name="link" />
        {{ bigQueryLabel }}
      </div>
    </button>
  } @else {
    <button iButton class="w-fit max-w-full" variant="secondary" (click)="openNewTabOnHost()">
      <div class="inline-flex items-center gap-1 truncate">
        <IIcon name="link" />
        {{ bigQueryLabel }}
      </div>
    </button>
  }
</td>
<td class="px-3.5 text-left">
  @if (shouldDisplayDropdownItems()) {
    <button
      iButton
      [iDropdownMenuTrigger]="rowMenu"
      placement="bottom-end"
      variant="secondary"
      size="icon-sm"
      class="opacity-0 group-hover:opacity-100"
    >
      <IIcon name="ellipsis" />
    </button>

    <ng-template #rowMenu>
      <IDropdownMenu>
        <button iDropdownMenuItem (click)="updateShareModal()">
          <IIcon name="edit" />
          {{ editLabel() }}
        </button>
        <button iDropdownMenuItem (click)="pauseOrResumeShareModal()">
          <IIcon name="pause" />
          {{ pauseResumeLabel() }}
        </button>
      </IDropdownMenu>
    </ng-template>
  }
</td>
